export default __webpack_public_path__ + "static/Gov.KempthorneCHAIRAdvBoard_social-504c75c60e016e2fba73f7fd5be80d1f.jpg";